/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Grid, Heading, HFlow, Icon, InfoLabel } from 'bold-ui'
import { Color } from 'csstype'
import { IvcfSubgrupoPerguntaEnum, RiscoVulnerabilidadeIvcfEnum } from 'graphql/types.generated'
import { formatDate } from 'util/date/formatDate'
import { isEmpty } from 'util/validation/Util'
import { IVCF_RESULTADOS, IVCF_SUBGRUPOS } from 'view/atendimentos/detail/soap/objetivo/ivcf/model-ivcf'

interface AcompanhamentoCondicaoSaudeIvcfAccordionPanelProps {
  riscoVulnerabilidade?: RiscoVulnerabilidadeIvcfEnum
  dataRegistro?: number
  subgrupos?: IvcfSubgrupoPerguntaEnum[]
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeIvcfAccordionPanel(
  props: Readonly<AcompanhamentoCondicaoSaudeIvcfAccordionPanelProps>
) {
  const { riscoVulnerabilidade, dataRegistro, subgrupos, iconColor } = props

  const styles = createStyles()

  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline' style={styles.content}>
      <Cell size={12}>
        <HFlow hSpacing={0.25} alignItems='center'>
          <Icon icon='fileWithItemsFilled' size={1} color={iconColor} />
          <Heading level={4}>IVCF-20</Heading>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Risco' placeholder='-' titleStyles={styles.title}>
          {riscoVulnerabilidade && colorLabel(riscoVulnerabilidade)}
        </InfoLabel>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Registrado em' placeholder='-' titleStyles={styles.title}>
          {formatDate(dataRegistro)}
        </InfoLabel>
      </Cell>
      <Cell size={6}>
        <InfoLabel title='Dimensões alteradas' placeholder='-' titleStyles={styles.title}>
          {!isEmpty(subgrupos) && subgrupos?.map((subgrupo) => IVCF_SUBGRUPOS[subgrupo]?.label).join('; ') + '.'}
        </InfoLabel>
      </Cell>
    </Grid>
  )
}

const colorLabel = (ivcfRiscoVulnerabilidade: RiscoVulnerabilidadeIvcfEnum) => {
  const styles = createStyles(ivcfRiscoVulnerabilidade)

  return (
    <HFlow hSpacing={0}>
      <div css={css([styles.indiceIvcf, styles.ivcfLabel])} />
      {ivcfRiscoVulnerabilidade.capitalize()}
    </HFlow>
  )
}

const createStyles = (risco?: RiscoVulnerabilidadeIvcfEnum) => ({
  indiceIvcf: css`
    ${risco && `background: ${IVCF_RESULTADOS[risco].colorScale.c40};`}
  `,
  ivcfLabel: `
    width: 1rem;
    height: 1rem;
    border-radius: 0.125rem;
    margin-right: 0.5rem;
  `,
  content: `
  padding: 1rem 0;
`,
  title: `
  padding-bottom: 0.25rem;
`,
})
